<template>
  <div>
    <div>
      <div class="bg">
        <FxedTop></FxedTop>
      </div>
      <div class="pageTitle">
        <div class=""></div>
        <div class="currentLocation">当前位置：首页 > 帮助中心</div>
      </div>
      <div class="mian">
        <div class="">
          <div class="">
            <img class="banner" src="@/assets/image/banner.png" />
            <div class="menu">
              <div
                class="item"
                style="background-color: #adacf6; cursor: pointer"
                @click="handleNavList(false)">
                <div class="text">
                  <div class="title">学员</div>
                  <div class="text">联系我们</div>
                </div>
                <img class="icon" src="@/assets/image/icon_2.png" />
              </div>
              <div
                class="item"
                style="background-color: #e4b393; cursor: pointer"
                @click="handleNavList(true)">
                <div>
                  <div class="title">平台</div>
                  <div class="text">常见问题</div>
                </div>
                <img class="icon" src="@/assets/image/icon_1.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 联系我们弹框 -->
      <div class="contactUs" v-show="dialogVisible">
        <div class="contactBg" @click="dialogVisible = false"></div>
        <div class="contact">
          <img
            class="guanbi"
            @click="dialogVisible = false"
            src="@/assets/image/关闭.png" />
          <div class="title">联系我们</div>
          <img
            src="@/assets/image/1241755506357_.pic.jpg"
            style="width: 500px" />
          <div
            style="
              padding: 0 36px;
              box-sizing: border-box;
              padding-bottom: 40px;
            ">
            <div style="margin-bottom: 10px">联系电话: 4001335833</div>
            <div>工作时间: 工作日周一到周五 (9:30-13:00,15:30-18:00)</div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import FxedTop from "@/components/FxedTop";
import Footer from "@/components/Footer.vue";
import * as cmsApi from "@/api/cms";
export default {
  components: {
    Footer,
    FxedTop,
  },
  data() {
    return {
      dialogVisible: false,
      loading: true,
      activities: [{}, {}, {}, {}],
      total: 0,
      navList: [
        {
          title: "常见问题",
          isShow: true,
        },
        {
          title: "联系我们",
          isShow: false,
        },
      ],

      iframeUrl: "",
      showIframe: false,
      showList: true,
    };
  },
  created() {
    this.loading = true;
    this.total = 0;
    this.getIndex(1);
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    backHelp() {
      this.iframeUrl = "";
      this.showIframe = false;
    },

    handleNavList(item) {
      if (!item) {
        this.dialogVisible = true;
      } else {
        if (this.activities.length > 0) {
          const article = this.activities[0];
          this.$router.push({
            path: "/details",
            query: { articleId: article.id, type: 1 },
          });
        } else {
          uni.showToast({
            title: "暂无数据",
            icon: "none",
          });
        }
      }
    },
    currentChange(envt) {
      this.loading = true;
      this.getIndex(envt);
    },
    async getIndex(index) {
      try {
        let article = await cmsApi.getArticleType({
          pageSize: 10000,
          pageNo: index,
          columnId: "1862793848552075299",
          moduleId: "1862788601565851699",
          type: 2,
        });

        this.activities = article.result.list;
        this.total = article.result.total;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.contactUs {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  .contactBg {
    width: 100vw;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.7);
  }
  .contact {
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    background: #fff;
    border-radius: 10px;
    z-index: 1;
    width: 500px;
    display: flex;
    flex-direction: column;
    font-size: 16px;
    .title {
      font-size: 20px;
      text-align: center;
      font-weight: bold;
      padding-top: 20px;
    }
  }
}

// 鼠标移入, 做一个放大的效果
.item:hover {
  transform: scale(1.02);
  box-shadow: 0 0 20px rgba(56, 126, 200, 0.5);
  transition: all 0.6s ease;
}

.mian {
  .banner {
    background: #ccc;
    width: 100%;
    height: 360px;
    margin-bottom: 20px;
  }
  .menu {
    display: flex;
    margin-bottom: 20px;
    .item {
      flex: 1;
      border-radius: 10px;
      height: 200px;
      background: #ccc;
      margin-right: 20px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      box-sizing: border-box;

      .title {
        font-size: 40px;
        font-weight: bold;
        color: #fff;
      }
      .text {
        font-size: 32px;
        color: #fff;
      }
      .icon {
        width: 150px;
        height: 150px;
        background: #fff;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.list {
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 20px;
  border-radius: 10px;
  // 阴影
  box-shadow: 0px 2px 0px 2px rgba($color: #000000, $alpha: 0.1);
  .items {
    line-height: 40px;
    margin-bottom: 10px;
    padding-left: 10px;
    cursor: pointer;
    border-bottom: 1px solid #ccc;
  }
}
.iframepage {
  width: 1200px;
  margin: 0 auto;
}
.sort {
  padding: 5px 20px;
  color: #fff;
  border-radius: 4px;
}
.qrcode {
  width: 200px;
  height: 200px;
  display: block;
  margin: 0 auto;
  margin-bottom: 10px;
  background: #ccc;
}
</style>
